module.exports = __webpack_public_path__ + "static/media/Martin.6167c1d9.jpg";